export default {
      id: "oc-res-repair-order-configuration-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-repair-order-configuration",
      toString: function () {
        return this.url;
      }
    }